import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CartProduct {
  productId: number;
}

export interface User {
  id: string;
  pw: string;
  cart?: CartProduct[];
}

interface UsersState {
  users: User[];
}

const initialState: UsersState = {
  users: [
    {
      id: 'admin',
      pw: '1234',
      cart: [],
    },
    {
      id: 'tester',
      pw: 'tester',
      cart: [],
    },
  ],
};

const usersSlice = createSlice({
  name: 'users',
  initialState: initialState,
  reducers: {
    addUser: (state, action: PayloadAction<User>) => {
      state.users.push(action.payload);
    },

    removeUser: (state, action: PayloadAction<string>) => {
      state.users = state.users.filter((user) => {
        return user.id !== action.payload;
      });
    },
  },
});

export const { addUser, removeUser } = usersSlice.actions;

export default usersSlice.reducer;
